import ReveiwDetailContainer from './ReveiwDetailContainer';
export default ReveiwDetailContainer;
